import { Box, Menu } from '@mui/material';
import { darken, styled } from '@mui/material/styles';

import CustomButton from 'components/CustomButton';

export const Content = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  width: '100%',
}));

export const StatusWraper = styled(Box)(({ theme }) => ({
  height: '42px',
  backgroundColor: theme.palette.general.lightGrey3,
  borderRadius: '6px',
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  padding: theme.spacing(0.5, 0.2, 0.5, 1.5),
  color: theme.palette.text.secondary,
}));

export const Status = styled(Box)(({ theme }) => ({
  backgroundColor: darken(theme.palette.general.lightGrey3, 0.15),
  height: '38px',
  padding: theme.spacing(0, 1),
  display: 'flex',
  alignItems: 'center',
  borderRadius: '6px',
  color: theme.palette.common.black,
}));

export const InfoWrapper = styled(Box)(({ theme }) => ({
  height: '42px',
  backgroundColor: darken(theme.palette.general.lightGrey3, 0.07),
  borderRadius: '6px',
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
  padding: theme.spacing(2, 1),
  color: theme.palette.common.black,
}));

export const ActionButton = styled(CustomButton)(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderColor: darken(theme.palette.general.lightGrey3, 0.07),
  color: theme.palette.common.black,
  height: '42px',

  '.MuiSvgIcon-root': {
    color: darken(theme.palette.general.lightGrey3, 0.07),
  },
}));

export const EditMenu = styled(Menu)(({ theme }) => ({
  '.MuiPaper-root': {
    borderRadius: '10px',
    border: `1px solid ${darken(theme.palette.general.lightGrey3, 0.07)}`,
    marginTop: theme.spacing(0.5),
  },

  '.MuiSvgIcon-root': {
    color: darken(theme.palette.general.lightGrey3, 0.07),
  },
}));
